"use client"

import { useState } from "react"
import type { Discount } from "@apps/gwservice/types"
import { DiscountSheet } from "~/components/discount-sheet"
import { Card } from "~/components/ui/card"
import { RemoteImg } from "~/components/ui/remote-img"

interface Props {
  discount: Discount
}

export function DiscountCard({ discount }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Card className="flex flex-row items-center p-0! w-full" onClick={() => setOpen(true)}>
        {discount.cover && (
          <div className="relative w-group-img self-stretch min-h-group-img shrink-0">
            <RemoteImg src={discount.cover.url} alt={discount.partner} className="object-cover size-full" />
          </div>
        )}
        <div className="flex-1 pl-m pb-s flex flex-col gap-1 min-w-0">
          <div className="flex items-start justify-between gap-xs">
            <div className="pt-s text-base line-clamp-2 hyphens-auto" lang="ru">
              {discount.partner}
            </div>
            <div className="bg-accent text-white text-xs font-bold px-xs py-0.5 rounded-tr-md rounded-bl-md shrink-0">
              -{discount.percent}%
            </div>
          </div>
          {discount.text && (
            <div className="text-sm pr-m text-muted-foreground line-clamp-2 hyphens-auto" lang="ru">
              {discount.text}
            </div>
          )}
        </div>
      </Card>
      <DiscountSheet discount={open ? discount : null} onClose={() => setOpen(false)} />
    </>
  )
}
